module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('mt-logo', {
    attrs: {
      "propWidth": 80
    }
  })], 1)], 1), _vm._v(" "), _c('h3', {
    staticClass: "mt--neutrals-dark-gray-02",
    on: {
      "click": function($event) {
        _vm.openStyleMenu = !_vm.openStyleMenu
      }
    }
  }, [_vm._v("\n      Style\n      "), _c('mt-icon', {
    attrs: {
      "iconName": _vm.styleToggleIcon,
      "color": "#718091"
    }
  })], 1), _vm._v(" "), _c('ul', {
    class: _vm.openStyleMenu ? 'on' : 'off',
    style: (_vm.stylesStyle)
  }, _vm._l((_vm.styles), function(item) {
    return _c('li', {
      key: item.label
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.route))
      }
    }, [_vm._v(_vm._s(item.label))])], 1)
  })), _vm._v(" "), _c('h3', {
    staticClass: "mt--neutrals-dark-gray-02",
    on: {
      "click": function($event) {
        _vm.openComponentsMenu = !_vm.openComponentsMenu
      }
    }
  }, [_vm._v("\n      Components\n      "), _c('mt-icon', {
    attrs: {
      "iconName": _vm.componentsToggleIcon,
      "color": "#718091"
    }
  })], 1), _vm._v(" "), _c('ul', {
    class: _vm.openComponentsMenu ? 'on' : 'off',
    style: (_vm.componentsStyle)
  }, _vm._l((_vm.components), function(item) {
    return _c('li', {
      key: item.label
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (item.route))
      }
    }, [_vm._v(_vm._s(item.label))])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-505f5044","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = RWYS
// module chunks = 0